import { BuildingViewerContent } from './components/react/content/BuildingViewerContent';
import { ComparisonSliderContent } from './components/react/content/ComparisonSliderContent';
import { Content } from './Content';
import { ImageLinkContent } from './components/react/content/ImageLinkContent';
import { InteractiveMapContent } from './components/react/content/InteractiveMapContent';
import { MediaGridContent } from './components/react/content/MediaGridContent';
import { MessageContent } from './components/react/content/MessageContent';
import { PDFContent } from './components/react/content/PDFContent';
import { SceneViewerContent } from './components/react/content/SceneViewerContent';
import { SlideshowContent } from './components/react/content/SlideshowContent';
import { VimeoContent } from './components/react/content/VimeoContent';
import { WebGLContent } from './components/react/content/WebGLContent';
import { YoutubeContent } from './components/react/content/YoutubeContent';

export const constructContent = (content: Content) => {
  switch (content.type) {
    case 'image-link':
      return <ImageLinkContent content={content} />;
    case 'media-grid':
      return <MediaGridContent content={content} />;
    case 'pdf':
      return <PDFContent content={content} />;
    case 'slideshow':
      return <SlideshowContent content={content} />;
    case 'vimeo':
      return <VimeoContent content={content} />;
    case 'webgl':
      return <WebGLContent content={content} />;
    case 'youtube':
      return <YoutubeContent content={content} />;
    case 'comparison-slider':
      return <ComparisonSliderContent content={content} />;
    case 'message':
      return <MessageContent content={content} />;
    case 'interactive-map':
      return <InteractiveMapContent content={content} />;
    case 'scene':
      return <SceneViewerContent content={content} />;
    case 'building-viewer':
      return <BuildingViewerContent content={content} />;
  }
};
